<div class="content">
  @if (searchService.getProductsLoading()) {
    <div class="page-spinner-container">
      <div class="css-spinner css-spinner--large"></div>
    </div>
  }
  <div class="search-container">
    <mat-form-field appearance="outline" class="search-field">
      <mat-label>Search warehouse deals</mat-label>
      <input autocapitalize="none"
        matTooltip="This seaches for words in the titles. Try using fewer words and check your spelling." matInput
        type="text" [formControl]="searchControl" (keyup.enter)="doSearch()" />
      <mat-icon matSuffix color="primary" (click)="doSearch()">search</mat-icon>
    </mat-form-field>
    <a routerLink="/search-help" class="search-help-link">Search tips</a>
  </div>
  <app-livefeed-mini [domain]="domain"></app-livefeed-mini>
  <div class="message start-message">
    <div>
      @if (affiliateEnabled) {
        <span><span class="hide-small-affiliate">As an Amazon Affiliate,</span> I
      earn from qualifying purchases.</span>
    }
  </div>
</div>
  <cdk-virtual-scroll-viewport [itemSize]="height" (scrolledIndexChange)="maybeGetNextProducts()">
<div [ngStyle]="{ 'height.px': height }" class="grid-box" *cdkVirtualFor="let productRow of productRows()">
  <app-product-row [productRow]="productRow" [cardWidth]="cardWidth()"></app-product-row>
</div>
@if (!searchService.getProductsLoading() && !searchService.endOfStream()) {
  <div class="button-container">
    @if (!searchService.getNextPageLoading()) {
      <button mat-flat-button color="accent"
        class="load-more-button" (click)="loadNextPage()">
        Load More
        <mat-icon>expand_more</mat-icon>
      </button>
    } @else {
      <div class="css-spinner css-spinner--small"></div>
    }
  </div>
} @else {
  <div class="message end-message">
    <div>{{ T["END_OF_RESULTS"][domain] }}</div>
  </div>
}

<app-amazon-ads class="amazon-ads"></app-amazon-ads>
</cdk-virtual-scroll-viewport>
</div>
<div class="scroll-top-button">
  @if (showScrollUpButton()) {
    <button mat-mini-fab color="accent" (click)="scrollToTop()">
      <mat-icon>keyboard_arrow_up</mat-icon>
    </button>
  }
</div>
